import { useDispatch } from "react-redux";
import {
  nextStep,
  prevStep,
  updateField,
} from "../../../store/reducers/users/usersForm.slice";

const StepContact = () => {
  const dispatch = useDispatch();
  const handleChange = (e) =>
    dispatch(
      updateField({
        name: e.target.name,
        value: e.target.value,
      }),
    );

  return (
    <div className="vstack gap-3">
      <div className="form-floating">
        <input
          className="form-control"
          name="telefono"
          placeholder="Teléfono"
          onChange={handleChange}
        />
        <label>Teléfono</label>
      </div>

      <div className="form-floating">
        <input
          className="form-control"
          name="correo"
          placeholder="Correo"
          onChange={handleChange}
        />
        <label>Correo</label>
      </div>

      <div className="d-flex justify-content-between">
        <button
          className="btn btn-outline-secondary"
          onClick={() => dispatch(prevStep())}
        >
          Atrás
        </button>

        <button
          className="btn btn-primary"
          onClick={() => dispatch(nextStep())}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default StepContact;
